/**
 * Core SFRA function for run everything everywhere
 * @param {Function || Object} include - stuff to run
 */
const processInclude = (include) => {
    if (typeof include === 'function') {
        include();
    } else if (typeof include === 'object') {
        Object.keys(include).forEach(function (key) {
            if (typeof include[key] === 'function') {
                include[key]();
            }
        });
    }
};

// Enqueues tasks to be executed afterwards
function enqueueTask(task) {
    window.requestAnimationFrame(task);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
const parseHtml = (html, map) => {
    const el = document.createElement('div');
    el.innerHTML = html;

    let htmlMap = {};
    for (var key in map) {
        if (map.hasOwnProperty(key)) {
            htmlMap[key] = el.querySelector(map[key]);
        }
    }

    return htmlMap;
};

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
const appendToUrl = (url, params) => {
    var newUrl = url;
    newUrl +=
        (newUrl.indexOf('?') !== -1 ? '&' : '?') +
        Object.keys(params)
            .map(function (key) {
                return key + '=' + encodeURIComponent(params[key]);
            })
            .join('&');

    return newUrl;
};

const lockScroll = () => {
    $('body, html').css('overflow-y', 'hidden');
};

const unlockScroll = () => {
    $('body, html').css('overflow-y', '');
};

/**
 * function for force lock scroll when open a modal or a drawer.
 * CAN CREATE SOME ISSUE WITH TOUCH EVENT - CHECK ON REAL DEVICE
 * the event is for prevent scrolling in iOS device
 */
function forceLockScroll() {
    $('body, html,.page')
        .css({'overflow-y': 'hidden', 'touch-action': 'none'})
        .on('touchmove', preventDefault);
}

function forceUnlockScroll() {
    $('body, html,.page')
        .css({'overflow-y': '', 'touch-action': ''})
        .off('touchmove', preventDefault);
}

function preventDefault(e) {
    e.preventDefault();
}

const cookieExists = (name) => {
    return document.cookie.split(';').filter((item) => {
        return item.trim().indexOf(`${name}=`) === 0;
    }).length;
};

const createCookie = (name, value = false, days = 0) => {
    var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};

const getCookie = (name) => {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length == 2) return parts.pop().split(';').shift();
    return '';
};

const deleteCookie = (name) => {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const isTouchDevice = () => {
    return (
        'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
    );
};

/**
 * Generic Ajax Call
 * @param {string} url - url for the ajax call
 * @param {string} method - default GET (is possible to use POST,PUT)
 * @param {object} data - use in POST method
 * @param {boolean} hideSpinner - default false, use true to hide the spinner
 * @returns Promise with the response of the ajax call
 */
function genericAjaxCall(url, method = 'GET', data = {}, hideSpinner = false) {
    if (!url) {
        console.error('Missing Url in ajax call');
        return;
    }
    if (hideSpinner !== true) {
        $.spinner().start();
    }
    return new Promise((resolve, reject) => {
        $.ajax({
            url: url,
            method: method,
            data: data,
            success: function (response) {
                if (hideSpinner !== true) {
                    $.spinner().stop();
                }
                resolve(response);
            },
            error: function (error) {
                if (hideSpinner !== true) {
                    $.spinner().stop();
                }
                console.error(error);
                reject(error);
            },
        });
    });
}

export {
    appendToUrl,
    cookieExists,
    createCookie,
    deleteCookie,
    enqueueTask,
    forceLockScroll,
    forceUnlockScroll,
    genericAjaxCall,
    getCookie,
    isTouchDevice,
    lockScroll,
    parseHtml,
    preventDefault,
    processInclude,
    unlockScroll,
};
